'use strict';

var React = require('react');
var IconBase = require('./dist/IconBase.js');

module.exports = function (props) {
    return React.createElement(IconBase, Object.assign({ viewBox: '0 0 1024 1024' }, props, {
        style: { width: '1em' }
    }), React.createElement(
        'g',
        null,
        React.createElement('path', { d: 'M1024 832c-106.042 0-192-85.96-192-192v-285.090c0-140.738-109.942-258.128-256-285.084v-69.826h-128v69.824c-146.064 26.958-256 144.346-256 285.084v285.092c0 106.040-85.962 192-192 192v64h429.598c-5.208 11.424-8.11 24.118-8.11 37.49 0 49.986 40.524 90.51 90.512 90.51 49.984 0 90.51-40.524 90.51-90.51 0-13.376-2.902-26.066-8.112-37.49h429.602v-64z' })
    ));
};